import React from 'react';
import styled from 'styled-components';
import { usePhotoBase64 } from '../hooks/usePhotoBase64';

const PageA4Paysage = styled.div`
  width: ${props => props.isPreview ? '290mm' : '297mm'};
  height: ${props => props.isPreview ? '200mm' : '210mm'};
  padding: ${props => props.isPreview ? '5mm' : '2mm'};
  background: white;
  font-family: 'Segoe UI', Arial, sans-serif;
  page-break-after: always;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: ${props => props.isPreview ? '5mm' : '6mm'};
  margin: ${props => props.isPreview ? '10px auto' : '0'};
  box-shadow: ${props => props.isPreview ? '0 4px 8px rgba(0,0,0,0.1)' : 'none'};
  border: ${props => props.isPreview ? '1px solid #ddd' : 'none'};
  
  @media print {
    margin: 0;
    padding: 2mm;
    page-break-after: always;
    box-shadow: none;
    border: none;
    width: 297mm;
    height: 210mm;
    gap: 6mm;
  }
  
  @media screen {
    ${props => props.isPreview && `
      transform: scale(0.8);
      transform-origin: top center;
      margin-bottom: 20px;
    `}
  }
`;

const CarteContainer = styled.div`
  width: ${props => props.isPreview ? '140mm' : '144mm'};
  height: ${props => props.isPreview ? '95mm' : '99mm'};
  border: 2px solid #2c3e50;
  border-radius: 8px;
  background: white;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  overflow: hidden;
  position: relative;
  
  @media print {
    border: 2px solid #2c3e50;
    box-shadow: none;
    break-inside: avoid;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    print-color-adjust: exact;
    font-size: 14px;
    width: 144mm;
    height: 99mm;
  }
`;

const Header = styled.div`
  height: 25mm;
  border-bottom: 1px solid #2c3e50;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto auto;
  
  @media print {
    border-bottom: 1px solid #2c3e50 !important;
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`;

const HeaderTop = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto auto;
  height: 15mm;
  gap: 0;
  
  @media print {
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`;

const TitreCarte = styled.div`
  padding: 2mm;
  display: flex;
  align-items: center;
  grid-column: 1;
  grid-row: 1;
  justify-content: center;
  border-bottom: 1px solid #2c3e50;
  margin-bottom: 1mm;
  padding-right: 0;
  
  @media print {
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
    print-color-adjust: exact !important;
    border-bottom: 1px solid #2c3e50 !important;
    padding-right: 0 !important;
  }
  
  h1 {
    font-size: 14px;
    margin: 0;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: #2c3e50;
    text-align: center;
    
    @media print {
      font-size: 16px !important;
      color: #2c3e50 !important;
      font-weight: bold !important;
      text-transform: uppercase !important;
      letter-spacing: 1px !important;
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
  }
`;

const NomAgent = styled.div`
  grid-column: 1;
  grid-row: 2;
  text-align: left;
  font-size: 12px;
  font-weight: bold;
  color: #2c3e50;
  display: flex;
  align-items: center;
  padding-left: 2mm;
  border-bottom: 1px solid #2c3e50;
  margin: 1mm 0;
  padding-right: 0;
  
  @media print {
    font-size: 14px !important;
    color: #2c3e50 !important;
    font-weight: bold !important;
    border-bottom: 1px solid #2c3e50 !important;
    text-align: left !important;
    padding-left: 2mm !important;
    padding-right: 0 !important;
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`;

const FonctionGroupe = styled.div`
  grid-column: 1;
  grid-row: 3;
  text-align: left;
  font-size: 10px;
  color: #2c3e50;
  display: flex;
  align-items: center;
  padding-left: 2mm;
  border-bottom: 1px solid #2c3e50;
  margin: 1mm 0;
  gap: 5mm;
  padding-right: 0;
  
  @media print {
    font-size: 16px !important;
    color: #2c3e50 !important;
    border-bottom: 1px solid #2c3e50 !important;
    text-align: left !important;
    padding-left: 2mm !important;
    padding-right: 0 !important;
    gap: 5mm !important;
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  
  .fonction {
    font-weight: bold;
    
    @media print {
      font-weight: bold !important;
      font-size: 16px !important;
    }
  }
  
  .groupe {
    font-weight: bold;
    
    @media print {
      font-weight: bold !important;
      font-size: 16px !important;
    }
  }
`;

const AnneeLogo = styled.div`
  padding: 2mm;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  grid-column: 2;
  grid-row: 1 / span 3;
  border-left: 1px solid #2c3e50;
  margin-left: 0;
  height: 100%;
  
  @media print {
    border-left: 1px solid #2c3e50 !important;
    margin-left: 0 !important;
    height: 100% !important;
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  
  .annee {
    font-size: 16px;
    font-weight: bold;
    color: #2c3e50;
    margin-bottom: 1mm;
    
    @media print {
      font-size: 18px !important;
      color: #2c3e50 !important;
      font-weight: bold !important;
      margin-bottom: 1mm !important;
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
  }
  
  .logo {
    width: 12mm;
    height: 12mm;
    background: ${props => props.hasCustomLogo ? 'transparent' : '#3498db'};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    font-size: 8px;
    overflow: hidden;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
    
    @media print {
      background: ${props => props.hasCustomLogo ? 'transparent' : '#3498db'} !important;
      border-radius: 50% !important;
      color: white !important;
      font-weight: bold !important;
      font-size: 10px !important;
      overflow: hidden !important;
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
      print-color-adjust: exact !important;
      
      img {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover !important;
        border-radius: 50% !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
    }
  }
`;

const InfoFonctionGroupe = styled.div`
  height: 10mm;
  padding: 2mm;
  display: flex;
  gap: 5mm;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #2c3e50;
  background: #f8f9fa;
  
  .fonction {
    font-size: 11px;
    color: #2c3e50;
    font-weight: bold;
    text-transform: uppercase;
    margin-right: 5mm;
  }
  
  .groupe {
    font-size: 11px;
    color: #2c3e50;
    font-weight: bold;
    text-transform: uppercase;
  }
`;

const CalendrierContainer = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: 1fr repeat(6, 1fr);
  grid-template-rows: repeat(5, 1fr);
  gap: 1px;
  padding: 2mm;
  margin: 0;
`;

const PhotoCase = styled.div`
  grid-column: 1;
  grid-row: 1 / span 3;
  border: 1px solid #3498db;
  border-radius: 4px;
  overflow: hidden;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  
  @media print {
    border: 1px solid #3498db !important;
    border-radius: 4px !important;
    overflow: hidden !important;
    background: #f8f9fa !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
    height: 100% !important;
    width: 100% !important;
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    
    @media print {
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
  }
  
  .no-photo {
    font-size: 8px;
    color: #7f8c8d;
    text-align: center;
    
    @media print {
      font-size: 8px !important;
      color: #7f8c8d !important;
      text-align: center !important;
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
  }
`;

const MoisCase = styled.div`
  grid-column: 1;
  grid-row: 4;
  border: 1px solid #bdc3c7;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  background-color: #ffffff;
  color: #2c3e50;
  
  @media print {
    border: 1px solid #bdc3c7 !important;
    background-color: #ffffff !important;
    color: #2c3e50 !important;
    font-size: 12px !important;
    font-weight: bold !important;
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`;

const JourCase = styled.div`
  border: 1px solid #bdc3c7;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: bold;
  background-color: #ffffff;
  border-radius: 2px;
  min-height: 8mm;
  
  @media print {
    border: 1px solid #bdc3c7;
    background-color: #ffffff;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    print-color-adjust: exact;
    font-size: 10px !important;
    min-height: 8mm !important;
  }
  
  .numero {
    font-size: 9px;
    color: #2c3e50;
    
    @media print {
      color: #2c3e50;
      -webkit-print-color-adjust: exact;
      color-adjust: exact;
      print-color-adjust: exact;
      font-size: 10px !important;
    }
  }
  
  .dimanche {
    font-size: 7px;
    color: #e74c3c;
    font-weight: bold;
    
    @media print {
      color: #e74c3c;
      -webkit-print-color-adjust: exact;
      color-adjust: exact;
      print-color-adjust: exact;
      font-size: 8px !important;
    }
  }
`;

const PreviewLabel = styled.div`
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  padding: 10px;
  margin-bottom: 20px;
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  color: #495057;
  font-weight: 500;
  
  small {
    display: block;
    margin-top: 5px;
    color: #6c757d;
    font-weight: normal;
  }
`;

const PhotoDisplay = ({ photoPath, alt }) => {
  const { photoBase64, loading } = usePhotoBase64(photoPath);
  
  if (loading) {
    return (
      <div className="no-photo">
        Chargement...
      </div>
    );
  }
  
  if (!photoBase64) {
    return (
      <div className="no-photo">
        PHOTO
      </div>
    );
  }
  
  return (
    <img 
      src={photoBase64} 
      alt={alt} 
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        borderRadius: '4px'
      }}
    />
  );
};

const CartePointage4ParPage = ({ cartes, isPreview = false, logoEntreprise = null }) => {
  if (!cartes || cartes.length === 0) return null;

  const getMoisNom = (numeroMois) => {
    const mois = [
      '', 'JANVIER', 'FÉVRIER', 'MARS', 'AVRIL', 'MAI', 'JUIN',
      'JUILLET', 'AOÛT', 'SEPTEMBRE', 'OCTOBRE', 'NOVEMBRE', 'DÉCEMBRE'
    ];
    return mois[numeroMois] || '';
  };

  // Organiser les jours en grille 7x5 avec photo intégrée
  const organiserJoursEnGrille = (jours) => {
    if (!jours || jours.length === 0) return [];
    
    const grille = [];
    let jourIndex = 0;
    
    // Créer 5 lignes
    for (let ligneIndex = 0; ligneIndex < 5; ligneIndex++) {
      const ligne = [];
      
      // Pour chaque ligne, créer 7 colonnes
      for (let colonneIndex = 0; colonneIndex < 7; colonneIndex++) {
        if (ligneIndex >= 0 && ligneIndex <= 2 && colonneIndex === 0) {
          // Cases de la photo (lignes 1-3, colonne 1)
          ligne.push(null);
        } else if (ligneIndex === 3 && colonneIndex === 0) {
          // Case du mois (4ème ligne, première colonne)
          ligne.push({ type: 'mois' });
        } else if (jourIndex < jours.length) {
          // Cases normales avec les jours
          ligne.push(jours[jourIndex]);
          jourIndex++;
        } else {
          // Cases vides
          ligne.push(null);
        }
      }
      
      grille.push(ligne);
    }
    
    return grille;
  };

  // Diviser les cartes en groupes de 4 pour chaque page A4 paysage
  const pages = [];
  for (let i = 0; i < cartes.length; i += 4) {
    pages.push(cartes.slice(i, i + 4));
  }

  return (
    <>
      {isPreview && (
        <PreviewLabel>
          📄 APERÇU D'IMPRESSION - Format A4 Paysage (4 cartes par page)
          <br />
          <small>Cet aperçu montre exactement ce qui sera imprimé</small>
        </PreviewLabel>
      )}
      
      {pages.map((pageCartes, pageIndex) => (
        <PageA4Paysage key={pageIndex} isPreview={isPreview}>
          {pageCartes.map((carte, carteIndex) => {
            const { agent, mois, annee, jours } = carte;
            const grilleJours = organiserJoursEnGrille(jours || []);

            return (
              <CarteContainer key={carteIndex} isPreview={isPreview}>
                <Header>
                  <HeaderTop>
                    <TitreCarte>
                      <h1>CARTE DE POINTAGE ABIDJAN</h1>
                    </TitreCarte>
                    
                    <NomAgent>
                      {agent.nom} {agent.prenoms}
                    </NomAgent>
                    
                    <FonctionGroupe>
                      <span className="fonction">FONCTION: {agent.fonction || 'N/A'}</span>
                      <span className="groupe">GROUPE: {agent.groupeNom || 'N/A'}</span>
                    </FonctionGroupe>
                    
                    <AnneeLogo hasCustomLogo={!!logoEntreprise}>
                      <div className="annee">{annee}</div>
                      <div className="logo">
                        {logoEntreprise ? (
                          <img src={logoEntreprise} alt="Logo Entreprise" />
                        ) : (
                          'Ets Coul.'
                        )}
                      </div>
                    </AnneeLogo>
                  </HeaderTop>
                </Header>

                <CalendrierContainer>
                  {/* Photo intégrée dans le calendrier (3 lignes) */}
                  <PhotoCase>
                    <PhotoDisplay 
                      photoPath={agent.photoPath} 
                      alt={`${agent.nom} ${agent.prenoms}`} 
                    />
                  </PhotoCase>
                  
                  {/* Mois dans une case du calendrier */}
                  <MoisCase>
                    {getMoisNom(mois)}
                  </MoisCase>
                  
                  {/* Reste des cases du calendrier */}
                  {grilleJours.map((ligne, ligneIndex) => (
                    ligne.map((jour, colonneIndex) => {
                      // Ignorer les cases spéciales
                      if (ligneIndex >= 0 && ligneIndex <= 2 && colonneIndex === 0) return null; // Photo
                      if (ligneIndex === 3 && colonneIndex === 0) return null; // Mois
                      
                      return (
                        <JourCase 
                          key={`${ligneIndex}-${colonneIndex}`}
                          style={{
                            gridColumn: colonneIndex + 1,
                            gridRow: ligneIndex + 1
                          }}
                        >
                          {jour ? (
                            jour.estDimanche ? (
                              <div className="dimanche">DIM</div>
                            ) : (
                              <div className="numero">{jour.numeroJourCalendaire}</div>
                            )
                          ) : (
                            <div></div>
                          )}
                        </JourCase>
                      );
                    })
                  ))}
                </CalendrierContainer>
              </CarteContainer>
            );
          })}
          
          {/* Remplir avec des cases vides si moins de 4 cartes */}
          {Array.from({ length: 4 - pageCartes.length }).map((_, index) => (
            <div key={`empty-${index}`}></div>
          ))}
        </PageA4Paysage>
      ))}
    </>
  );
};

export default CartePointage4ParPage; 